import { ADDITIONAL_UNITS_PICKER, BUTTON_CLICK, BUY_NOW_BUTTON_CLICK, CLICKED_LINK, FAQ_INTERACTION, HOVER_INTERACTION, MODAL_INTERACTION, NAVIGATION_CLICK, PAGE_VIEW, PRODUCT_CLICK, SCROLL_INTERACTION, TALK_TO_SALES_CLICK } from '../../constants/event-tracking/EventKeys';
export const getClickedAdditionalUnitsPickerEvent = properties => {
  return {
    key: ADDITIONAL_UNITS_PICKER,
    properties
  };
};
export const getClickedLinkEvent = properties => {
  return {
    key: CLICKED_LINK,
    properties: Object.assign({
      action: 'click'
    }, properties)
  };
};
export const getModalInteractionEvent = properties => {
  return {
    key: MODAL_INTERACTION,
    properties: Object.assign({}, properties)
  };
};
export const getNavigationClickEvent = properties => {
  return {
    key: NAVIGATION_CLICK,
    properties: Object.assign({}, properties)
  };
};
export const getTalkToSalesEvent = properties => {
  return {
    key: TALK_TO_SALES_CLICK,
    properties: Object.assign({
      action: 'click talk to sales'
    }, properties)
  };
};
export const getBuyNowButtonClickEvent = properties => {
  return {
    key: BUY_NOW_BUTTON_CLICK,
    properties: Object.assign({
      action: 'click buy now'
    }, properties)
  };
};
export const getProductClickEvent = properties => {
  return {
    key: PRODUCT_CLICK,
    properties: Object.assign({}, properties)
  };
};
export const getButtonClickEvent = properties => {
  return {
    key: BUTTON_CLICK,
    properties: Object.assign({
      action: 'click button'
    }, properties)
  };
};
export const getScrollInteractionEvent = properties => {
  return {
    key: SCROLL_INTERACTION,
    properties: Object.assign({}, properties)
  };
};
export const getFaqInteractionEvent = properties => {
  return {
    key: FAQ_INTERACTION,
    properties: Object.assign({}, properties)
  };
};
export const getHoverInteractionEvent = properties => {
  return {
    key: HOVER_INTERACTION,
    properties: Object.assign({}, properties)
  };
};
export const getPageViewEvent = properties => {
  return {
    key: PAGE_VIEW,
    properties: Object.assign({}, properties)
  };
};